//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from "better-scroll";
import MyCard from "@/components/Card";
export default {
  name: "BookDetail",
  components: {
    MyCard
  },
  mounted() {
    this.initScroll();
    this.fetchBookData();
  },
  data() {
    return {
      isbn: this.$route.query.isbn,
      marcid: this.$route.query.marcid,
      bscroll: "",
      bookInfo: {},
      isInfoLimit: true,
      bookBrief: "",
      authorBrief: "",
      isAuthorLimit: true,
      infoLibs: []
    };
  },
  methods: {
    initScroll() {
      let wrapper = document.querySelector(".p-detail");
      if (!this.bscroll) {
        this.bscroll = new BScroll(wrapper, {
          click: true,
          bounce: {
            top: false,
            bottom: false,
            left: false,
            right: false
          }
        });
      } else {
        this.bscroll.refresh();
      }
    },
    fetchBookData() {
      this.$vux.loading.show();
      this.$http("post", "/book/details", {
        isbn: this.isbn,
        marcid: this.marcid
      })
        .then(res => {
          this.$vux.loading.hide();
          // 图书信息
          let bookDetail = res.data.bookDetail;
          // 如果接口没有图书信息则用之前的数据
          if (Object.keys(bookDetail).length > 0) {
            this.bookInfo = {
              bookName: bookDetail["title"],
              isbn: this.isbn,
              infos: [
                {
                  name: "作者",
                  value: bookDetail["author"]
                    ? bookDetail["author"].join(",")
                    : ""
                },
                {
                  name: "出版社",
                  value: bookDetail["publisher"] ? bookDetail["publisher"] : ""
                },
                {
                  name: "出版时间",
                  value: bookDetail["pubdate"] ? bookDetail["pubdate"] : ""
                },
                {
                  name: "ISBN",
                  value: this.isbn
                },
                {
                  name: "页数",
                  value: bookDetail["pages"]
                }
              ]
            };
          } else {
            try {
              this.bookInfo = sessionStorage.getItem("bookInfo")
                ? JSON.parse(sessionStorage.getItem("bookInfo"))
                : {};
            } catch (error) {
              // eslint-disable-next-line
            }
          }
          document.title = this.bookInfo.bookName;
          this.bookBrief = bookDetail["summary"] ? bookDetail["summary"] : "";
          this.authorBrief = bookDetail["author_intro"]
            ? bookDetail["author_intro"]
            : "";
          // 馆藏信息
          this.infoLibs = res.data.bookCollection.map(lib => {
            let inLibBooks = 0;
            lib.isopen = false;
            lib.gc.forEach(book => {
              if (book.ztai === "在馆") {
                inLibBooks += 1;
              }
            });
            lib.inLibBooks = inLibBooks;
            return lib;
          });
        })
        .catch(err => {
          // eslint-disable-next-line
          console.log(err);
          this.$vux.loading.hide();
        });
    }
  }
};
